<div *ngIf="!isNative">
  <app-header [isSidenavShowing]="isSidenavShowing" (onMenuShow)="setSidenavShow($event)" *ngIf="this.router.url !=='/health-check'"></app-header>
  <mat-sidenav-container [style]="isSidenavShowing ? { maxHeight: 'calc(100vh - 70px)' } : null">
    <mat-sidenav *ngIf="this.router.url !=='/health-check'" id="primary-sidenav" mode="over" position="end" [(opened)]="isSidenavShowing" class="d-lg-none"
      style="width: 100%" #sidenav>
      <app-sidenav [isShowing]="isSidenavShowing" [sidenavRef]="sidenav"></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content>
      <main>
        <div class="component-container">
          <assurant-loader></assurant-loader>
          <pgh-loader-progress></pgh-loader-progress>
          <router-outlet></router-outlet>
        </div>
      </main>
      <app-chat-agent *ngIf="!isSidenavShowing"></app-chat-agent>
      <app-footer *ngIf="this.router.url !=='/health-check'"></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div *ngIf="isNative">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
